import { useMutation, useQueryClient } from "react-query";

import { crearRegistroRecepcion, updateRegistroRecepcion, deleteRegistroRecepcion} from '../../services/RegistroRecepciones';

import { toast } from 'react-hot-toast';
const queryKey = "recepcion";

export const useRecepcionMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
   // toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addRecepcion = useMutation((body) => crearRegistroRecepcion(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateRecepcionD = useMutation(
    (body) => updateRegistroRecepcion( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeRecepcion = useMutation((id) => deleteRegistroRecepcion( id), {
    onSuccess,
    onError,
  });

  return { addRecepcion, updateRecepcionD, removeRecepcion };
};
export default useRecepcionMutations;